import React from "react";
// css
import styles from "../../styles/CreateAccount.module.scss";
import "simplebar/dist/simplebar.min.css";
import { FormCard, Select } from "@suralink/samurai/ui";
import { DateFormat, TimeFormat, TimeZone } from "../../enums/timeAndDate";

const isNumber = (value: any) => isNaN(Number(value)) === false;
function enumArray(enumme: any) {
  let arr = Object.keys(enumme)
    .filter(isNumber)
    .map((key: any) => {
      let enumObj = {
        label: enumme[key],
        value: key * 1,
      };
      return enumObj;
    });
  return arr;
}

const timezoneOptions = enumArray(TimeZone);
const dateFormatOptions = enumArray(DateFormat);
const timeFormatOptions = enumArray(TimeFormat);

function AccountSettingsCard({
  timezoneSetting,
  dateFormatSetting,
  timeFormatSetting,
  setTimezoneSetting,
  setDateFormatSetting,
  setTimeFormatSetting,
}: any) {
  const selectTimezone = (option: any) => {
    setTimezoneSetting(option);
  };

  const selectDateFormat = (option: any) => {
    setDateFormatSetting(option);
  };

  const selectTimeFormat = (option: any) => {
    setTimeFormatSetting(option);
  };

  return (
    <FormCard
      style={{
        width: "328px",
        background: "#FBFCFF",
        border: "1px solid #E6EDF5",
        padding: "24px 48px 24px 40px",
        margin: "0 8px",
      }}
    >
      <h3 className={styles.cardHeaderText}>Account Options</h3>
      <Select
        style={{
          margin: "16px 0 0 0",
        }}
        options={timezoneOptions}
        selected={timezoneSetting}
        onSelect={selectTimezone}
        textual
        placeholder={timezoneOptions[0].label}
        label={"Time zone"}
      />
      <hr
        style={{
          border: 0,
          height: 0,
          borderTop: "1px solid #e7e9eb",
          borderBottom: "none",
          width: "248px",
        }}
      />

      <Select
        style={{
          margin: "16px 0 0 0",
        }}
        options={dateFormatOptions}
        selected={dateFormatSetting}
        onSelect={selectDateFormat}
        textual
        placeholder={dateFormatOptions[0].label}
        label={"Date format"}
      />
      <hr
        style={{
          border: 0,
          height: 0,
          borderTop: "1px solid #e7e9eb",
          borderBottom: "none",
          width: "248px",
        }}
      />

      <Select
        style={{
          margin: "16px 0 0 0",
        }}
        options={timeFormatOptions}
        selected={timeFormatSetting}
        onSelect={selectTimeFormat}
        textual
        placeholder={timeFormatOptions[0].label}
        label={"Time format"}
      />
    </FormCard>
  );
}

export default AccountSettingsCard;
